package com.zq.webproject.ui.resources

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.Link
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.zq.webproject.model.Product
import com.zq.webproject.model.Resource
import com.zq.webproject.utils.UrlLauncher
import org.jetbrains.compose.ui.tooling.preview.Preview

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ResourceInfoScreen(
    product: Product,
    onBackClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    println("ResourceInfoScreen - 渲染资源信息页面，商品: ${product.name}, 百度网盘链接: ${product.baiduUrl}")
    
    Scaffold(
        topBar = {
            TopAppBar(
                title = { Text(text = "资源信息") },
                navigationIcon = {
                    IconButton(onClick = onBackClick) {
                        Icon(
                            imageVector = Icons.AutoMirrored.Filled.ArrowBack,
                            contentDescription = "返回"
                        )
                    }
                },
                colors = TopAppBarDefaults.topAppBarColors(
                    containerColor = Color(0xFF1E88E5),
                    titleContentColor = Color.White,
                    navigationIconContentColor = Color.White
                )
            )
        }
    ) { paddingValues ->
        Column(
            modifier = modifier
                .fillMaxSize()
                .padding(paddingValues)
                .padding(16.dp)
                .verticalScroll(rememberScrollState())
        ) {
            // 商品标题
            Text(
                text = product.name,
                fontSize = MaterialTheme.typography.headlineSmall.fontSize,
                fontWeight = FontWeight.Bold,
                modifier = Modifier.padding(bottom = 16.dp)
            )

            // 商品描述
            if (!product.description.isNullOrBlank()) {
                Card(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(bottom = 16.dp),
                    elevation = CardDefaults.cardElevation(defaultElevation = 4.dp)
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(16.dp)
                    ) {
                        Text(
                            text = "商品描述",
                            fontSize = MaterialTheme.typography.titleMedium.fontSize,
                            fontWeight = FontWeight.SemiBold,
                            modifier = Modifier.padding(bottom = 8.dp)
                        )
                        
                        Text(
                            text = product.description ?: "",
                            fontSize = MaterialTheme.typography.bodyMedium.fontSize
                        )
                    }
                }
            }

            // 注意事项
            Text(
                text = "注意事项：\n1. 请妥善保管网盘链接和提取码\n2. 如遇到链接失效，请联系客服\n3. 资源仅供学习交流使用",
                fontSize = MaterialTheme.typography.bodySmall.fontSize,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )

            Spacer(modifier = Modifier.height(32.dp))

            // 查看资源链接按钮（直接从 image3 获取百度网盘链接）
            if (!product.baiduUrl.isNullOrBlank()) {
                OutlinedButton(
                    onClick = {
                        println("ResourceInfoScreen - 点击打开网盘链接: ${product.baiduUrl}")
                        UrlLauncher.openUrl(product.baiduUrl)
                    },
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(50.dp),
                    shape = RoundedCornerShape(25.dp),
                    colors = ButtonDefaults.outlinedButtonColors(
                        contentColor = Color(0xFF1E88E5)
                    )
                ) {
                    Icon(
                        imageVector = Icons.Default.Link,
                        contentDescription = "链接",
                        modifier = Modifier.size(20.dp)
                    )
                    Spacer(modifier = Modifier.width(8.dp))
                    Text(
                        text = "查看资源链接",
                        fontSize = 16.sp,
                        fontWeight = FontWeight.Medium
                    )
                }
            }
        }
    }
}

@Preview(showBackground = true)
@Composable
fun ResourceInfoScreenPreview() {
    MaterialTheme {
        ResourceInfoScreen(
            product = Product(
                id = 1,
                name = "Kotlin Multiplatform 开发实战教程",
                price = 199.0,
                category = "编程教程",
                imageUrl = "https://example.com/image.jpg",
                sales = 1250,
                views = 3580,
                description = "这是一套完整的 Kotlin Multiplatform 跨平台开发教程，包含理论讲解和实战项目。适合有 Kotlin 基础的开发者学习。课程内容涵盖 Android、iOS、Web 等多个平台的开发技巧。",
                status = 1,
                createdAt = "2024-01-20T10:30:00",
                updatedAt = "2024-01-23T15:45:00",
                baiduUrl = "https://pan.baidu.com/s/1a2b3c4d5e6f7g8h9i0j",
                extractCode = "abc123",
                otherResources = listOf(
                    Resource(
                        name = "配套源码",
                        url = "https://github.com/example/kmp-tutorial"
                    ),
                    Resource(
                        name = "课件PPT",
                        url = "https://example.com/slides.pdf"
                    )
                )
            ),
            onBackClick = { println("Preview - 返回按钮点击") }
        )
    }
}